import Behaviour from "../../lib/ui/Behaviour";
import { Path } from "../../lib/runescape/pathing";
import Widget from "../../lib/ui/Widget";
import lodash from "lodash";
import { C } from "../../lib/ui/constructors";
import { NislIcon } from "../ui/nisl";
import { PathStepEntity } from "../ui/map/entities/PathStepEntity";
import { util } from "../../lib/util/util";
import { TreeArray } from "../../lib/util/TreeArray";
import assert from "assert";
import { ewent, observe } from "../../lib/reactive";
import { GameLayer } from "../../lib/gamemap/GameLayer";
import KeyValueStore from "../../lib/util/KeyValueStore";
import { PathStepHeader } from "../ui/pathing/PathStepHeader";
import { deps } from "../dependencies";
import { lazy } from "../../lib/Lazy";
import { ScanTree } from "../cluetheory/scans/ScanTree";
var hbox = C.hbox;
var span = C.span;
var hboxl = C.hboxl;
var index = util.index;
export class SectionMemory {
    constructor() {
        this.data = KeyValueStore.instance().variable("preferences/pathsectionmemory");
        if (!this.data.get()) {
            this.data.set({});
        }
    }
    hash(method, sub_id) {
        if (sub_id)
            return method.pack.local_id + method.method.id + sub_id;
        return method.pack.local_id + method.method.id;
    }
    async get(method, sub_id) {
        return (await this.data.get())?.[this.hash(method, sub_id)];
    }
    async store(method, section, sub_id) {
        const value = (await this.data.get()) ?? {};
        value[this.hash(method, sub_id)] = section;
        await this.data.set(value);
    }
    static instance() {
        return SectionMemory._instance.get();
    }
}
SectionMemory._instance = lazy(() => new SectionMemory());
export class PathDisplayWithSectionControl extends Widget {
    constructor(sections, current_section_id, step_graphics, template_resolver) {
        super();
        this.sections = sections;
        this.current_section_id = current_section_id;
        this.step_graphics = step_graphics;
        this.template_resolver = template_resolver;
        this.section_selected = ewent();
        this.selected_section = undefined;
        this.render();
    }
    render() {
        this.empty();
        if (this.sections && this.current_section_id) {
            let section_link = TreeArray.getPath(this.sections, this.current_section_id);
            {
                section_link.forEach((node, i) => {
                    if (i == 0 || node?.type != "inner")
                        return; // Ignore root node and steps
                    let parent = section_link[i - 1];
                    assert(parent.type == "inner");
                    if (parent.children.length <= 1)
                        return; // Don't draw section controls if there is just one
                    let section_id = parent.children.indexOf(node);
                    if (node.type == "inner") {
                        const has_next = section_id < parent.children.length - 1;
                        const has_prev = section_id > 0;
                        hbox(has_prev ? NislIcon.sectionArrow("left").withClick(() => {
                            let cp = lodash.clone(this.current_section_id);
                            cp[i - 1] -= 1;
                            this.setCurrentSection(cp);
                        }) : c().css("width", "11px"), span(node.value.name).css("flex-grow", "1").css("text-align", "center").css2({
                            //"background": "#16242a",
                            "border-left": has_prev ? "1px solid #b8770f" : "none",
                            "border-right": has_next ? "1px solid #b8770f" : "none",
                            "border-radius": "5px",
                        }).tooltip("This path has multiple sections. Use the arrows to navigate between them."), has_next ? NislIcon.sectionArrow("right").withClick(() => {
                            let cp = lodash.clone(this.current_section_id);
                            cp[i - 1] += 1;
                            this.setCurrentSection(cp);
                        }) : c().css("width", "11px")).appendTo(this);
                    }
                });
            }
            this.selected_section = (() => {
                let n = index(section_link, -2);
                assert(n.type == "inner");
                return n.children.map(c => {
                    assert(c.type == "leaf");
                    return c.value;
                });
            })();
            if (deps().app.settings.settings.solving.info_panel.path_step_list == "show") {
                this.selected_section.forEach((step, index) => {
                    let sectionindex = lodash.clone(this.current_section_id);
                    sectionindex[sectionindex.length - 1] = index;
                    let graphics_node = TreeArray.index(this.step_graphics, sectionindex);
                    assert(graphics_node.type == "leaf");
                    if (graphics_node.value.step.type == "cosmetic")
                        return;
                    new PathDisplayWithSectionControl.StepRow(sectionindex, step, this.template_resolver)
                        .setAssociatedGraphics(graphics_node.value)
                        .appendTo(this);
                });
            }
        }
    }
    setCurrentSection(ids) {
        this.current_section_id = TreeArray.fixIndex(this.sections, ids);
        this.render();
        this.section_selected.trigger(this.selected_section);
    }
    onSelection(f) {
        this.section_selected.on(f);
        return this;
    }
}
(function (PathDisplayWithSectionControl) {
    class StepRow extends Widget {
        constructor(section_index, step, template_resolver) {
            super();
            this.section_index = section_index;
            this.step = step;
            this.template_resolver = template_resolver;
            this.highlighted = observe(false);
            this.associated_graphics = null;
            this.highlighted.subscribe(v => {
                this.toggleClass("ctr-neosolving-path-legend-highlighted", v);
                // TODO: Cause the entity to be highlighted on hover without locking it
                /*if (v) this.associated_graphics?.parent?.getRoot()?.lockEntity(this.associated_graphics, true)
                else if (this.associated_graphics?.isActive()) this.associated_graphics?.parent?.getRoot()?.lockEntity(null)*/
            });
            const index = util.index(this.section_index, -1);
            let order = c().text(`${index + 1}.`);
            const { icon, content } = PathStepHeader.renderTextAndIconSeparately(step);
            hboxl(order, icon, content).addClass("ctr-neosolving-path-legend")
                .on("mouseover", () => this.setHighlight(true))
                .on("mouseleave", () => this.setHighlight(false))
                .appendTo(this);
        }
        setAssociatedGraphics(graphics) {
            this.associated_graphics = graphics;
            if (graphics) {
                //graphics.setHighlightable(true)
                this.associated_graphics.highlighted.subscribe(v => {
                    this.setHighlight(v);
                });
            }
            return this;
        }
        setHighlight(v) {
            this.highlighted.set(v);
        }
    }
    PathDisplayWithSectionControl.StepRow = StepRow;
})(PathDisplayWithSectionControl || (PathDisplayWithSectionControl = {}));
export default class PathControl extends Behaviour {
    constructor(parent) {
        super();
        this.parent = parent;
        this.section_memory = SectionMemory.instance();
        this.method = null;
        this.scan_node = null;
        this.sectioned_path = null;
        this.path_layer = new GameLayer();
        this.step_graphics = null;
        this.widget = null;
        this.section_selected = ewent();
    }
    begin() {
        this.path_layer.addTo(this.parent.map_layer);
    }
    end() {
        this.path_layer.remove();
    }
    /**
     * Sets the path displayed in the legend and on the map.
     * Automatically splits it into appropriate sections, use {@link setSections} for more fine-grained control.
     * @param path
     * @param node The scan tree node this path belongs to, if any
     */
    setPath(path, node = null) {
        this.set(node?.method, Path.Section.split_into_sections(path), null, node?.node);
    }
    setSections(sections, active_id = null) {
        this.set(null, sections, active_id);
    }
    setMethod(method) {
        let sectioned = TreeArray.init({ name: "root" });
        if (method.method.pre_path && method.method.pre_path.length > 0) {
            const pre = TreeArray.add(sectioned, Path.Section.split_into_sections(method.method.pre_path, "Pre Path"));
            pre.value.is_preferred_section = true;
        }
        const main = TreeArray.add(sectioned, Path.Section.split_into_sections(method.method.main_path, "Main Path"));
        main.value.is_preferred_section = true;
        if (method.method.post_path && method.method.post_path.length > 0) {
            TreeArray.add(sectioned, Path.Section.split_into_sections(method.method.post_path, "Post Path"));
        }
        if (sectioned.children.length == 1)
            sectioned = sectioned.children[0];
        this.set(method, sectioned);
    }
    async set(method, sections, active_id = null, node = null) {
        this.sectioned_path = sections;
        this.method = method;
        this.scan_node = node;
        if (method && !active_id) {
            // No forced section id given, retrieve one from memory
            active_id = await this.section_memory.get(method, this.scan_node ? ScanTree.Augmentation.NodeId.hash(ScanTree.Augmentation.NodeId.of(this.scan_node)) : null);
        }
        if (!active_id) {
            // Still no section id, find a reasonable default
            let fallback_id = [];
            let tree = sections;
            while (tree.type == "inner" && tree.children.some(c => c.type == "inner")) {
                let next_id = tree.children.findIndex(c => c.type == "inner" && c.value.is_preferred_section);
                if (next_id < 0)
                    next_id = tree.children.length - 1;
                fallback_id.push(next_id);
                tree = tree.children[next_id];
            }
            active_id = fallback_id;
        }
        const section_id = TreeArray.fixIndex(this.sectioned_path, active_id || []);
        this.path_layer.clearLayers();
        this.step_graphics = TreeArray.map(this.sectioned_path, (step) => {
            return new PathStepEntity(step)
                .setInteractive()
                .addTo(this.path_layer);
        });
        this.renderWidget(section_id);
    }
    reset() {
        this.sectioned_path = null;
        this.method = null;
        this.widget?.remove();
        this.widget = null;
        this.path_layer.clearLayers();
        return this;
    }
    renderWidget(active_id) {
        this.widget?.remove();
        this.widget = null;
        this.section_control = null;
        const w = c();
        if (this.sectioned_path) {
            this.section_control = new PathDisplayWithSectionControl(this.sectioned_path, active_id, this.step_graphics, this.parent.app.template_resolver)
                .onSelection(p => {
                if (this.method) {
                    this.section_memory.store(this.method, this.section_control.current_section_id, this.scan_node ? ScanTree.Augmentation.NodeId.hash(ScanTree.Augmentation.NodeId.of(this.scan_node)) : null);
                }
                this.section_selected.trigger(p);
            })
                .addClass("ctr-neosolving-solution-row");
            // Only actually add the widget if there is something to show to avoid borders showing up
            if (!this.section_control.container.is(":empty"))
                this.section_control.appendTo(w);
        }
        if (this.section_control)
            this.section_selected.trigger(this.section_control.selected_section);
        if (w.container.is(":empty"))
            return;
        this.widget = w.appendTo(this.parent.map_layer.path_container);
    }
}
